import React, { lazy } from 'react';
import { CheckCircle } from 'lucide-react';
import { Button } from '../ui/Button';
export function SalesLetter() {
  const features = [{
    num: '1',
    title: 'Más de 200 Recetas Paso a Paso, Diseñadas Por Especialistas en Nutrición Animal',
    desc: 'Cada receta viene con instrucciones claras, ingredientes exactos, porciones por peso y tamaño de tu mascota, y el tiempo de preparación real (la mayoría: menos de 15 minutos). Es como tener un nutricionista veterinario en tu cocina, guiándote de la mano en cada preparación.',
    sub: 'Recetas para perros pequeños, medianos y grandes. Para gatos jóvenes y adultos. Para mascotas con alergias, problemas digestivos, sobrepeso o que necesitan ganar masa muscular.'
  }, {
    num: '2',
    title: 'Lista de Ingredientes Exacta y Económica — Sin Desperdicios, Sin Dudas',
    desc: "Cada receta incluye la lista de compras exacta con cantidades precisas. Nada de 'un puñadito' o 'a gusto'. Comprás exactamente lo que necesitás, nada más.",
    sub: 'Tu bolsillo lo va a agradecer — en la mayoría de los casos, gastás entre 40% y 60% menos que con alimentos comerciales de la misma calidad nutricional. Todo con ingredientes que encontrás en cualquier supermercado argentino. Sin importaciones, sin productos exóticos, sin excusas.'
  }, {
    num: '3',
    title: 'Protocolo de Transición de 20 Días — Resultados Visibles, Garantizados',
    desc: 'No es magia. Es ciencia aplicada. El protocolo te dice exactamente qué darle a tu mascota cada día durante 20 días para hacer la transición sin estrés digestivo.',
    sub: 'Al final de esos 20 días vas a ver: pelaje más brillante, más energía, menos vómitos, mejor digestión, ojos más vivos y un humor completamente diferente. Cuando las piezas encajan así... la transformación se produce sola.'
  }, {
    num: '4',
    title: 'Guía de Alimentos Permitidos y Prohibidos — Nunca Más Ese Miedo',
    desc: '¿Puede comer uva? ¿Cebolla? ¿Arroz? ¿Huevo crudo? Terminá con la incertidumbre de una vez.',
    sub: 'La guía cubre más de 150 alimentos con explicación de por qué sí o por qué no, y en qué cantidades. Clara, visual, imprimible y pegable en la heladera.'
  }, {
    num: '5',
    title: 'Planes Adaptados a Condiciones Especiales — Para el Peludo Único de Tu Casa',
    desc: 'Planes especiales para mascotas con: problemas renales, diabetes, alergias alimentarias, artritis, sobrepeso, recuperación post-cirugía, y cachorros en crecimiento.',
    sub: 'No importa cuál sea la situación de tu peludo. Hay un plan diseñado exactamente para él o ella.'
  }];
  return <section className="py-10 px-4 bg-cream" data-id="element-238">
      <div className="max-w-3xl mx-auto" data-id="element-239">
        <div className="text-center mb-6" data-id="element-240">
          <img src="https://cdn.magicpatterns.com/uploads/pSv2ng6MhBh2zMqcv1PFEw/20260318_0907_Image_Generation_simple_compose_01km0df5vne80rmqbgk5v4crcv_(1).webp" alt="Ingredientes naturales y frescos para mascotas" className="rounded-2xl shadow-lg mx-auto max-w-lg w-full object-cover aspect-[16/10] mb-4 border-4 border-white" loading="lazy" data-id="element-241" />
          {/* Agregada la propiedad loading="lazy" al elemento img */}
          <h2 className="text-3xl md:text-5xl font-black text-forest-green mb-3 leading-tight text-balance font-serif" data-id="element-242">
            ¿Qué hace que este sistema sea 10 veces mejor que todo lo que
            probaste antes?
          </h2>
          <div className="w-24 h-1.5 bg-gold mx-auto rounded-full" data-id="element-243"></div>
        </div>

        <div className="space-y-6" data-id="element-244">
          {features.map((feat, idx) => <div key={idx} className="bg-white p-5 md:p-6 rounded-2xl shadow-md border border-gray-100 border-t-4 border-t-gold relative mt-4" data-id="element-245">
              <div className="absolute -top-6 -left-4 md:-left-6 w-14 h-14 md:w-16 md:h-16 bg-forest-green text-gold flex items-center justify-center rounded-xl font-serif font-black text-2xl md:text-3xl shadow-lg border-4 border-white" data-id="element-246">
                #{feat.num}
              </div>

              <h3 className="text-2xl md:text-3xl font-black text-forest-green mb-2 mt-4 md:mt-2 leading-tight font-serif" data-id="element-247">
                {feat.title}
              </h3>

              <p className="text-gray-700 text-lg md:text-xl mb-3 leading-relaxed font-medium" data-id="element-248">
                {feat.desc}
              </p>

              <div className="bg-green-50/80 p-4 rounded-xl border border-green-200 flex gap-3 items-start shadow-inner" data-id="element-249">
                <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-250" />
                <p className="text-green-900 font-bold text-base md:text-lg leading-relaxed" data-id="element-251">
                  {feat.sub}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-8 text-center" data-id="element-252">
          <Button fullWidth className="md:w-auto shadow-glow-lg" data-id="element-253">
            QUIERO TRANSFORMAR A MI MASCOTA AHORA
          </Button>
        </div>
      </div>
    </section>;
}